import * as Event from '../tools/Event';
import { addClass, removeClass } from '../tools/DOM';
import { MQ } from '../tools/MQ';
import throttle from 'lodash.throttle';


export const init = () => {
	const menu = document.querySelector('.b-profile__nav');
	const FIXED_CLASS = 'is-fixed';
	let offset = 0;
	let isInit = false;

	if (!menu) return;

	const init = () => {
		removeClass(menu, FIXED_CLASS);
		isInit = false;

		if (MQ('tabletMax')) return;

		const height = window.innerHeight;
		offset = menu.offsetTop + menu.offsetHeight;

		if (offset > height) {
			addClass(menu, FIXED_CLASS);
			isInit = true;
		}

		onScroll();
	};

	const onScroll = () => {
		if (!isInit) return;

		const scrolled = (document.documentElement.scrollTop || document.body.scrollTop || 0) + window.innerHeight;


		if (scrolled >= offset) {
			removeClass(menu, FIXED_CLASS);
		} else {
			addClass(menu, FIXED_CLASS);
		}
	};


	init();

	Event.on(window, 'resize', throttle(init, 100));
	Event.on(window, 'scroll', throttle(onScroll, 100));
};
